import { API2_HOST } from 'helpers/urlHelper';
import {
  baseGetWithoutParam,
  baseSearch,
  basePost,
  basePatchOnlyUrl
} from 'services/base-services/baseService';

export const searchOutstandingRequests = async request => {
  return await baseSearch(`${API2_HOST}/sls-stock-request/overview`, request);
};

export const cancelRequestItems = async ids => {
  return await basePatchOnlyUrl(`${API2_HOST}/sls-stock-request/bulk-cancel`, {
    ids
  });
};

export const checkExistingRequest = async (productId, areaId) => {
  return await baseGetWithoutParam(
    `${API2_HOST}/sls-stock-request/check-existing?productId=${productId}&areaId=${areaId}`
  );
};

export const submitStockRequest = async request => {
  return await basePost(`${API2_HOST}/sls-stock-request`, request);
};
